import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { loaderActionSlice,msgPromtsuccess } from "../features/userSlice";
// Global application constants
export const APP_NAME = "Tara 567";
export const APP_VERSION = "1.0.0";


// API Endpoints
export const API_BASE_URL = "https://tara567.us/tara_secure_path/application_api/";
export const GET_CONTACTS_URL = `${API_BASE_URL}/contacts`;
export const ADD_CONTACT_URL = `${API_BASE_URL}/add-contact`;

// Messages
export const ERROR_MESSAGE = "Something went wrong, please try again.";
export const SUCCESS_MESSAGE = "Operation completed successfully.";

export const toastCss={
    position: "top-center",
    autoClose: 1600,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    zIndex:'9999'
  };

  export const routeObject = {
    '/login': 'Login',
    '/sign-up': 'SignupPage',
    '/M_pin': 'MpinForm',
    '/Otp': 'OtpForm',
    '/login_mpin': 'Login_mpin',
    '/download-now': 'LotusMatka',
    '/profile': 'Profile',
    '/privacy-policy': 'Privacy Policy',
    '/how-to-play': 'How to play',
    '/payment-status': 'Payment status',
    '/game-rates': 'Game rates',
    '/my-bid': 'Bid History',
    '/all-bid': 'All Bids',
    '/account-statement': 'Account Statement',
    '/game_type/:gameName': 'Game Types',
    '/:chart_ype/:gameName': 'Charts',
    '/game_type/:gameName/:gameType': 'Play Game',
    '/game_type_single/:gameName/:gameType': 'SingleGame',
    '/game_type/:gameName/half_sangam': 'SangamComponent',
    '/game_type/:gameName/full_sangam': 'SangamComponent',
    '/deposit': 'Deposite',
    '/withdraw': 'Withdrawal',
    '/wallet_histroy': 'Wallet Management',
    '/add_fund_auto': 'Add Fund Upi',
    '/add_fund_user': 'Add Fund Manual',
    '/add_bank_details': 'Bank Details',
    '/fund_histry/:TYPE': 'Fund History',
    '/request_history': 'Deposite History',
  };
  
  export const getFirstSixLetters=(str) =>{
    if (str?.length <= 6) {
      return str; // Return the entire string if it has 6 or fewer characters
    } else {
      return str?.substring(0, 6); // Return the first 6 characters
    }
  }

  export const  removeDuplicates=(arr)=>{
    return arr.filter((value, index, self) => 
      index === self.findIndex((t) => (
        JSON.stringify(t) === JSON.stringify(value)
      ))
    );
  }
  export const checkTime = (closeTime) => {
    function timeStringToMinutes(timeStr) {
      // Split the time string into components
      const [time, meridian] = timeStr.toLowerCase().split(" ");
      const [hours, minutes] = time.split(":").map(Number);
    
      // Convert hours to 24-hour format
      const totalHours = meridian === "pm" && hours !== 12 ? hours + 12 : (meridian === "am" && hours === 12 ? 0 : hours);
    
      // Calculate total minutes
      const totalMinutes = totalHours * 60 + minutes;
    
      return totalMinutes;
    }
    const now = new Date();
    const currentTimeInMinutes = now.getHours() * 60 + now.getMinutes();
    const targetTimeInMinutes = timeStringToMinutes(closeTime); 
     return currentTimeInMinutes < targetTimeInMinutes;
  };

  export const msgAccessPromt=({dispatch,msg,error})=>{
        if(msg==='LOADING'){
           dispatch(loaderActionSlice(error));
        }else{
           dispatch(msgPromtsuccess({msg,error}));
           dispatch(loaderActionSlice(false));

        }
   
  }


  export const Compoicon=()=>{
    const bordertyle={
        display: 'inline-flex',
        justifyContent: 'center',
        float:'right',
        alignItems: 'center',
        border: '2px solid #F5F5F5', // Outer border
        borderRadius: '50%', // Circular shape
        padding: '6px', // Space between icon and border
        boxShadow:'5px 5px 5px #FAFAFA',
      };
    return(<div style={bordertyle}><FontAwesomeIcon icon={faAngleRight} style={{color:'#251b1b'}}/></div>);
}

export const  sumOfDigits=(number)=> {
  return number
    .toString() // Convert number to string
    .split("") // Split string into individual digits
    .map(Number) // Convert each character back to a number
    .reduce((acc, digit) => acc + digit, 0) % 10 || '0'; // Sum up the digits
}

export const nodataStyle=(line)=>{
   
    return <div className="Empty_data">{line}</div>;
}